import { useEffect, useRef } from "react";

type Particle = {
	x: number;
	y: number;
	size: number;
	speedX: number;
	speedY: number;
	color: string;
	opacity: number;
};

const COLORS = ["#FF3333", "#0099FF", "#FFD700"];

const ParticleEffect = () => {
	const canvasRef = useRef<HTMLCanvasElement>(null);
	const particlesRef = useRef<Particle[]>([]);

	useEffect(() => {
		const canvas = canvasRef.current;
		if (!canvas) return;

		const ctx = canvas.getContext("2d");
		if (!ctx) return;

		const createParticle = (): Particle => ({
			x: Math.random() * canvas.width,
			y: Math.random() * canvas.height,
			size: Math.random() * 3 + 1,
			speedX: (Math.random() - 0.5) * 2,
			speedY: (Math.random() - 0.5) * 2,
			color: COLORS[Math.floor(Math.random() * COLORS.length)],
			opacity: Math.random() * 0.5 + 0.2,
		});

		// Inicializa partículas
		particlesRef.current = Array.from({ length: 50 }, createParticle);

		const animate = () => {
			ctx.clearRect(0, 0, canvas.width, canvas.height);

			particlesRef.current.forEach((particle) => {
				// Atualiza posição
				particle.x += particle.speedX;
				particle.y += particle.speedY;

				// Verifica limites
				if (particle.x < 0 || particle.x > canvas.width) particle.speedX *= -1;
				if (particle.y < 0 || particle.y > canvas.height) particle.speedY *= -1;

				// Desenha partícula
				ctx.beginPath();
				ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
				ctx.fillStyle = `${particle.color}${Math.floor(particle.opacity * 255)
					.toString(16)
					.padStart(2, "0")}`;
				ctx.fill();
			});

			requestAnimationFrame(animate);
		};

		// Ajusta tamanho do canvas
		const handleResize = () => {
			canvas.width = window.innerWidth;
			canvas.height = window.innerHeight;
		};

		handleResize();
		window.addEventListener("resize", handleResize);
		animate();

		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return (
		<canvas
			ref={canvasRef}
			className='fixed inset-0 pointer-events-none z-0'
			style={{ opacity: 0.3 }}
		/>
	);
};

export default ParticleEffect;
